import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ToastContainer } from "react-toastify";

import Login from "./components/Auth/Login";
import SignUp from "./components/Auth/SignUp";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";
import Home from "./components/Home/Home";
import ShopifyLanding from "./components/Home/ShopifyLanding";
import Pricing from "./components/Pricing/Pricing";
import PrivacyPolicy from "./components/Legal/PrivacyPolicy";
import TermsOfService from "./components/Legal/TermsOfService";
import Error from "./components/Error";
// import OAuthRedirect from './components/OAuthRedirect';
import Dashboard from "./components/Dashboard/Dashboard";
import GoogleAdsCallback from "./components/AdAuthCallbacks/GoogleAdsCallback";
import ProtectedRoute from "components/Auth/ProtectedRoute";
import MetaAdsCallback from "components/AdAuthCallbacks/MetaAdsCallback";
import TikTokAdsCallback from "./components/AdAuthCallbacks/TikTokAdsCallback";
import SnapchatAdsCallback from "./components/AdAuthCallbacks/SnapchatAdsCallback";
import RedditAdsCallback from "./components/AdAuthCallbacks/RedditAdsCallback";
import LinkedInAdsCallback from "./components/AdAuthCallbacks/LinkedInAdsCallback";
import ShopifyOAuthAdsCallback from "components/AdAuthCallbacks/ShopifyOAuthAdsCallback";
import { LanguageProvider } from "./i18n/LanguageContext";
import ClaudeConnectors from "./components/Claude/ClaudeConnectors";

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Porte d'entrée marchand Shopify — publique. Pose ?source=shopify
              sur l'inscription, ce qui fige users.signup_source et déclenche
              le parcours marchand (voir services/onboardingJourneys.js). */}
          <Route path="/shopify" element={<ShopifyLanding />} />

          {/* Tarifs — page publique, accessible sans compte */}
          <Route path="/pricing" element={<Pricing />} />
          {/* OneBotAds comme connecteur Claude : page publique, plateformes si connecte */}
          <Route path="/claude" element={<ClaudeConnectors />} />

          {/* Pages légales — publiques, requises par Google/Meta/TikTok pour la vérification OAuth */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />

          {/* Dashboard */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Ad Callbacks */}
          <Route
            path="/ads/google-callback"
            element={
              <ProtectedRoute>
                <GoogleAdsCallback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ads/meta-callback"
            element={
              <ProtectedRoute>
                <MetaAdsCallback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ads/tiktok-callback"
            element={
              <ProtectedRoute>
                <TikTokAdsCallback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tiktok-ads-callback"
            element={
              <ProtectedRoute>
                <TikTokAdsCallback />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ads/snap-callback"
            element={
              <ProtectedRoute>
                <SnapchatAdsCallback />
              </ProtectedRoute>
            }
          />

          {/* Reddit renvoie sur cette URL après autorisation — elle doit être
              déclarée à l'identique dans les réglages de l'app Reddit. */}
          <Route
            path="/ads/reddit-callback"
            element={
              <ProtectedRoute>
                <RedditAdsCallback />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ads/linkedin-callback"
            element={
              <ProtectedRoute>
                <LinkedInAdsCallback />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ads/shopify-callback"
            element={
              <ProtectedRoute>
                <ShopifyOAuthAdsCallback />
              </ProtectedRoute>
            }
          />

          {/* Error */}
          <Route path="/error" element={<Error />} />
        </Routes>
      </Router>
      <ToastContainer />
    </LanguageProvider>
  );
};

export default App;
